'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import menuManager from 'menu-manager';

export const MOBILE_MENU_ID = 'mobile';

export default class Hamburger extends Component {
    constructor(el) {
        super(el);
        this.defineVariables();
        this.initHamburger();
    }

    defineVariables() {
        this.menuId = MOBILE_MENU_ID;

        this.isOpened = false;
        this.$hamburger = $(".js-hamburger");
        this.$header = $(".js-header");
        this.$body = $("body");
    }

    initHamburger() {
        this.$hamburger.on('click', this.toggleMenu.bind(this));

        menuManager.init(this.menuId, {
            default: {
                level: 0,
                close: this.close.bind(this),
                open: this.open.bind(this)
            },
            desktop: {
                isEnabled: false
            }
        });
    }

    toggleMenu() {
        if (this.isOpened) {
            menuManager.close(this.menuId);
        } else {
            menuManager.open(this.menuId);
        }
    }

    open() {
        this.isOpened = true;
        this.$header.addClass("is-mobile-open");
    }

    close() {
        this.isOpened = false;
        this.$header.removeClass("is-mobile-open");
    }
}

Hamburger.id = 0;



// WEBPACK FOOTER //
// ./app/components/hamburger/js/generic.hamburger.js